export default "__VITE_ASSET__BC_t1uMx__"